module.exports = __webpack_public_path__ + "assets/media/email-sent.504f01c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/FindMyTeam/FindMyTeamEmailSent/email-sent.svg
// module id = 3222
// module chunks = 0